import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { b2bStockConfig } from "@/lib/datasetRegistry"

// Thin config module — driven by `b2bStockConfig`. Page-specific JSX is the
// breadcrumb (headerBanner) and the supported-templates dropzone line.
// Controller renders "admin/b2b/Stock".
export default function Stock(props: Omit<DatasetUploadsPageProps, "config">) {
  return (
    <DatasetUploadsPage
      config={b2bStockConfig}
      headerBanner={
        <div className="mb-2 flex items-center gap-1.5 text-xs text-ink-muted">
          <span>Data</span>
          <span>/</span>
          <span>B2B Data</span>
          <span>/</span>
          <span className="text-ink-body font-medium">B2B - Stock</span>
        </div>
      }
      dropzoneDetail={
        <p className="mt-1 text-xs text-ink-muted">
          Template yang didukung: IDG (StockBaik), IDM (REG/SC, Legacy 3.001.0), Worksheet (MIDI, SAT, SIL)
        </p>
      }
      {...props}
    />
  )
}
